<template>
  <div>
    <!-- PAGINATION BLOCK -->
    <div
      class="paging-block d-flex flex-wrap justify-content-start align-items-start w-auto h-auto py-auto"
    >
      <!-- PAGINATION NAVS -->
      <div
        class="paging-nav"
        :class="page_active === 1 ? 'disabled' : ''"
        @click="$emit('navigatePage', page_active - 1)"
      >
        <router-link to>Prev</router-link>
      </div>

      <div
        class="paging-item"
        :class="index + 1 === page_active ? 'paging-active' : ''"
        @click="$emit('navigatePage', index + 1)"
        v-for="(page, index) in page_count"
        :key="index"
      >
        <router-link to>{{ index + 1 }}</router-link>
      </div>
      <!-- PAGINATION NAVS -->
      <div
        class="paging-nav"
        :class="page_active === total_pages ? 'disabled' : ''"
        @click="$emit('navigatePage', page_active + 1)"
      >
        <router-link to>Next</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",

  props: {
    paging: Object,
  },

  data() {
    return {
      total_pages: this.paging.pageCount,
      page_count: Array(this.paging.pageCount).fill(true),
      page_active: this.paging.currentPage,
    };
  },

  watch: {
    paging: "updatePagination",
  },

  methods: {
    updatePagination() {
      this.total_pages = this.paging.pageCount;
      this.page_count = Array(this.paging.pageCount).fill(true);
      this.page_active = this.paging.currentPage;
    },
  },
};
</script>

<style lang="scss">
// PAGINATION
.paging-block {
  margin: 30px 0 10px;
  vertical-align: middle;
  margin-bottom: 40px;

  @include breakpoint_max(md) {
    margin-bottom: 90px;
  }
}

.paging-item,
.paging-nav {
  position: relative;
  margin-right: 15px;
  font-size: 14px;
  line-height: 19px;
  color: $color_grey_dark;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  @include breakpoint_max(md) {
    margin-right: 10px;
    font-size: 13px;
  }

  a {
    @include transform_center;
  }

  &:hover {
    background: $border_grey;

    a {
      color: $color_text;
    }
  }
}

.paging-item {
  @include equal_min_edge(30);
  border-radius: 50%;
}

.paging-nav {
  @include custom_min_edge(50, 30);
  padding: 5px 7px;
  border-radius: 2px;
}

.paging-active {
  background: $border_grey;
  color: $color_text;
}
</style>
